export default __webpack_public_path__ + "static/HalvarBreit-Lt-d9f18cc985ab4277d8b1963438e6cb35.woff";